var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',{attrs:{"placeholder":_vm.item.caption,"value":_vm.form.searchText,"name":"searchText","id":"searchText","type":"text","rowClass":"padding-16","rightIcon":"magnify","hasEraseIcon":!!_vm.form.searchText,"vuelidateObj":_vm.$v.form.searchText},on:{"input":_vm.handleInput,"erase":_vm.handleErase}})
}
var staticRenderFns = []

export { render, staticRenderFns }